import React from "react";
const CardHeaderWithBottomLine = ({ title }) => {
  return (
    <div className="d-add-basic_details">
      <p>{title}</p>
    </div>
  );
};
export default CardHeaderWithBottomLine;
